import { useEffect } from 'react';
import { Url } from 'finhelper';
import withRouter from '../../components/WithRouter/withRouter';

const CallbackNotification = () => {
  // const [show, setShow] = useState(props.show ? props.show : false);

  //TODO доработать возвращение с ответом успеха/ошибки

  useEffect(() => {
    const params = Url.getParams();

    //хоть ошибка, хоть нет, вернем обратно пользователя
    //TODO нужно доработать в приложении чтобы показывать если вернули с ошибкой по интеграции зенмани
    if (params?.action === 'zenmoney_auth_success') {
      redirectToApp('/');
    } else if (params?.action === 'zenmoney_auth_error') {
      redirectToApp('/');
    }
  }, []);

  const redirectToApp = (route = '/') => {
    const deepLink = `whiteswan://zenmoney/callback`;

    if (/iPhone|iPad|iPod/i.test(navigator.userAgent)) {
      // iOS
      window.location.href = deepLink;
    } else if (/Android/i.test(navigator.userAgent)) {
      // Android
      window.location.href = deepLink;
    }
  };

  return null; // или можешь оставить твою модалку как есть
};

export default withRouter(CallbackNotification);
